import { z } from "zod";
import { sessionStore } from "../../../lib/store";

const SHORT_URL_UTM_SOURCE = "juisci_short_url";

const store = sessionStore("juisciShortUrlSession", false, z.boolean());

function readUtmSourceFromLocation(): string | null {
  const params = new URLSearchParams(globalThis.location.search);
  const value = params.get("utm_source");
  return value === null ? null : value;
}

export function isJuisciShortUrlSession(): boolean {
  if (store.get()) return true;
  if (readUtmSourceFromLocation() === SHORT_URL_UTM_SOURCE) {
    store.set(true);
    return true;
  }
  return false;
}
